import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import Layout from "@/layout";
import Script from "next/script";
import Head from "next/head";
import Header from "@/components/webHeader";
import {
  getDesignHome,
  TITLE,
  WORKBENCH_DESCRIPTION,
  WORKBENCH_KEYWORDS,
} from "@/constants";
import cs from "classnames";
import usePPTGenerate from "@/hooks/usePPTGenerate";
import arrow from "@/assets/images/banner-arrow.png";
import Image from "next/image";
import TypeTabs from "./components/typeTabs";
import {
  FOOTER_TABS,
  FooterTabItem,
  FooterTabKey,
  MAX_PAGE_COUNT,
  MIN_PAGE_COUNT,
  PageItem,
  StepType,
  TabKey,
  TABS,
} from "@/constants/workbench";
import { statTrack } from "@/utils/mtstat";
import DeepSeekBtn from "@/components/deepSeekBtn";
import PageSelect from "@/components/pageSelect";
import InAWordContent from "./components/inAWordContent";
import Try from "./components/try";
import MdEditor from "./components/mdEditor";
import ImportFile from "./components/importFile";
import dynamic from "next/dynamic";
import { useGetUserInfo } from "@/hooks/useUserHelper";
import { debounce } from "lodash";
import { getQuery } from "@/utils/query";
import Record from "./components/record";
import { Material } from "@/services/workbench/types";
import Templates from "./components/templates";
import { Button, message, InputNumber } from "antd";
import "antd/es/message/style/css";
import "antd/es/button/style/css";
import "antd/es/input-number/style/css";
import IconFont from "@meitu/xdesign-icon-font";
import { PPTOutlineLoading } from "@/components/fetchLoading/views/pptOutlineLoading";
import Scrollbars from "react-custom-scrollbars";
import TagSelect from "./components/tagSelect";
import nextArrow from "@/assets/images/next-arrow.png";
import CustomTyped from "@/components/typed";
import OutlineTree from "./components/outlineTree";
import TemplateSelect from "./components/templateSelect";
import { CreatePPTProgress } from "./components/createPPTProgress";
import FloatHelp from "@meitu/xdesign-widgets/dist/floatHelp";
import Pages from "./components/dragPage";
import { arrayMove } from "@dnd-kit/sortable";
import { v4 as uuidv4 } from "uuid";
import { getPageItemIndexById } from "./components/dragPage/utils";
import PageNumberSelect from "@/components/pageNumberSelect";
import { Popover } from "antd";
import "antd/es/popover/style/css";
import tipsIcon1 from "@/assets/images/aiDeepen.png";
import tipsIcon2 from "@/assets/images/edit.png";
import tipsIcon3 from "@/assets/images/ppt.png";

const PromotionComponent = dynamic(
  () => import("@/components/promotionModal"),
  {
    ssr: false,
  }
);
const OverseasAccessModal = dynamic(
  () => import("@meitu/xdesign-widgets/dist/overseasAccessModal"),
  {
    ssr: false,
  }
);
const Disclaimer = dynamic(
  () => import("@meitu/xdesign-widgets/dist/disclaimer"),
  {
    ssr: false,
  }
);

const WIDHT = 224;
const GAP = 20;
const DEFAULT_COL = 4;

interface IProps {
  isPersonal: boolean;
}

const TEXT_MAP: Record<StepType, { title: string; desc: string }> = {
  [StepType.outline]: {
    title: "大纲生成",
    desc: "轻松编辑大纲，或保持原样继续",
  },
  [StepType.template]: {
    title: "模板选择",
    desc: "选择您心仪的PPT模板进行完整PPT的生成",
  },
  [StepType.page]: {
    title: "按页生成",
    desc: "根据每张卡片内容生成PPT，支持拖拽移动合并、增删和修改内容",
  },
  [StepType.ppt]: {
    title: "",
    desc: "",
  },
  [StepType.write]: {
    title: "",
    desc: "",
  },
};

const WebWorkbench: React.FC<IProps> = (props) => {
  const { isPersonal } = props;
  const {
    isWriteStep,
    activeTab,
    setActiveTab,
    chancelUpload,
    timer,
    setLoading,
    isDeepSeek,
    setIsDeepSeek,
    isInAWord,
    pageSizeSelect,
    activePageSize,
    setActivePageSize,
    keyword,
    keywordChangeHandle,
    placeholder,
    enterHandle,
    freeCreate,
    recommendClick,
    activeRecommendIndex,
    recommendPromptList,
    isPasteText,
    mdRef,
    richTextLen,
    richText,
    richTextChange,
    visibleTooltip,
    mdHtml,
    isImportFile,
    loading,
    importFileData,
    generateHandle,
    isOutlineStep,
    isTemplateStep,
    step,
    scrollRef,
    streamEnd,
    streamStr,
    treeData,
    outlineEnd,
    onDeleteTree,
    isPreset,
    lenSelect,
    activeLen,
    setActiveLen,
    generateTypeSelect,
    activeGenerateType,
    setActiveGenerateType,
    pptLoading,
    createAiPPT,
    onPresetStreamTypedComplete,
    onAddTree,
    treeInputChange,
    tagSelect,
    activeTag,
    setActiveTag,
    activeTemplate,
    templateList,
    setActiveTemplate,
    handleErrorMessage,
    createPPTLoading,
    createPPTPercent,
    cancelCreatePPT,
    handleNext,
    back,
    onOutlineBlur,
    isPageStep,
    pageItems,
    setPageItems,
    pageHistorySet,
    pageHistoryState,
    pageNumber,
    setPageNumber,
    showPageNumber,
  } = usePPTGenerate();
  const [footerTabs, setFooterTabs] = useState<FooterTabItem[]>([]);
  const [activeFooterTab, setActiveFooterTab] = useState<FooterTabKey>();
  const userInfo = useGetUserInfo();
  const [col, setCol] = useState(DEFAULT_COL);
  const [totalWidth, setTotalWidth] = useState(
    WIDHT * DEFAULT_COL + GAP * (DEFAULT_COL - 1)
  );
  const query = getQuery();
  const clickAble = useRef(true);
  const pageTipsRef = useRef<HTMLDivElement>(null);
  const computerCol = () => {
    // 根据屏幕宽度 1. 小于1024 4列 -出现横向滚动 2. 1024～1279 4列 3. 1280～1439 4列 4. 1440 ～ 1679 5列 5 1680～ 1919 6列 6. 1920～ 2159 7列 7. 大于等于 2160 8列
    // 计算列数
    const col =
      window.innerWidth < 375
        ? 2
        : window.innerWidth < 1024
        ? 4
        : window.innerWidth < 1280
        ? 4
        : window.innerWidth < 1440
        ? 4
        : window.innerWidth < 1680
        ? 5
        : window.innerWidth < 1920
        ? 6
        : window.innerWidth < 2160
        ? 7
        : 8;
    setCol(col);
  };

  // 防抖监听窗口变化
  const debounceResize = debounce(computerCol, 100);

  useEffect(() => {
    computerCol();
    window.addEventListener("resize", () => debounceResize());
    return () => {
      window.removeEventListener("resize", () => debounceResize());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 根据列数，宽度，间距计算出总的宽度
    const totalWidth = WIDHT * col + GAP * (col - 1);
    setTotalWidth(totalWidth);
  }, [col]);

  useEffect(() => {
    const arr = !userInfo?.id
      ? FOOTER_TABS.filter((v) => !v.forceLogin)
      : FOOTER_TABS;
    setFooterTabs(arr);
    setActiveFooterTab(arr?.[0]?.key);
  }, [userInfo]);

  const recordClick = async (item: Material) => {
    statTrack("tools_click_ppt_home", {
      click_type: "ppt_record",
    });
    const url = `${getDesignHome()}/design`;

    window.open(
      `${url}?id=${item.id}&type=record&from=${
        query?.from || "record"
      }&origin=ai-ppt`
    );
  };

  const onCreate = () => {
    statTrack("tools_click_ppt_home", {
      click_type: "create_blank_template",
    });
    const url = `${getDesignHome()}/design`;
    window.open(
      `${url}?create=241&createEmptyPoster=true&width=1920&height=1080&unit=px&from=design_now_left&modeId=0&pick_id=2130&extraInfo=%257B%2522bg%2522%253A%257B%2522backgroundColor%2522%253A%2522%2523ffffffff%2522%257D%257D&isPPT=true`
    );
  };

  const fileUploadCallback = async (file: string, type: string) => {
    if (chancelUpload.current) {
      clearTimeout(timer.current);
      return;
    }
    if (type === "pdf" || type === "ppt" || type === "pptx") {
      clearTimeout(timer.current);
      await generateHandle(file, {
        otherParams: {
          type: 6,
          file_type: type,
        },
        isUpload: true,
        showProcessModal: false,
        forceLogin: false,
        toEdit: false,
      });
    } else {
      importFileData.current = file;
      freeCreate({});
    }
  };

  const refresh = () => {
    statTrack("tools_click_ppt_home", {
      click_type: "recreate_outline_bottom",
    });
    freeCreate({
      is_recreate: "1",
    });
  };

  const onReorder = (
    list: PageItem[],
    activeIndex: number,
    overIndex: number
  ) => {
    if (
      (overIndex === 0 && list[0].type === "封面") ||
      (overIndex === list.length - 1 && list[list.length - 1].type === "致谢")
    ) {
      return;
    }
    pageHistorySet(arrayMove(pageItems, activeIndex, overIndex));
    setPageItems((items) => arrayMove(items, activeIndex, overIndex));
  };

  const onMerge = (fromId: string, toId: string) => {
    console.log(`合并 ${fromId} 到 ${toId}`);
    const fromIndex = getPageItemIndexById(pageItems, fromId);
    const toIndex = getPageItemIndexById(pageItems, toId);

    const fromItem = pageItems[fromIndex];
    const toItem = pageItems[toIndex];
    if (
      (toIndex === 0 && toItem.type === "封面") ||
      (toIndex === pageItems.length - 1 && toItem.type === "致谢")
    ) {
      return;
    }

    // index 小的排在前面
    const mergedContent =
      fromIndex < toIndex
        ? `${fromItem.content}\n${toItem.content}`
        : `${toItem.content}\n${fromItem.content}`;

    const list = pageItems
      .map((item) => {
        if (item.id === toId) {
          // 全新的ID，触发重新渲染
          return { ...item, id: uuidv4(), content: mergedContent };
        }
        return item;
      })
      .filter((item) => item.id !== fromId);

    pageHistorySet(list);
    setPageItems(list);
    statTrack("tools_click_ppt_home", {
      click_type: "combine_page",
    });
  };

  const onRemove = (id: string) => {
    if (pageItems.length <= MIN_PAGE_COUNT) {
      message.error(`卡片最少支持${MIN_PAGE_COUNT}张`);
      return;
    }
    const list = pageItems.filter((item) => item.id !== id);
    pageHistorySet(list);
    setPageItems(list);
  };

  const onAdd = (id: string) => {
    if (pageItems.length >= MAX_PAGE_COUNT) {
      statTrack("toast_show", {
        notification_type: "page_limit_notification",
        position: "aippt_home_page_edit",
      });
      message.error(`卡片最多支持${MAX_PAGE_COUNT}张`);
      return;
    }
    const index = pageItems.findIndex((item) => item.id === id);
    // const item = pageItems[index];
    // 在index后插入一个新元素
    const list = [
      ...pageItems.slice(0, index + 1),
      { id: uuidv4(), content: "", type: "内容" },
      ...pageItems.slice(index + 1),
    ];
    pageHistorySet(list);
    setPageItems(list);
  };

  const onCopy = (id: string) => {
    if (pageItems.length >= MAX_PAGE_COUNT) {
      message.error("卡片最多支持30张");
      return;
    }
    const index = pageItems.findIndex((item) => item.id === id);
    const item = pageItems[index];
    const list = [
      ...pageItems.slice(0, index + 1),
      { id: uuidv4(), content: item.content, type: item.type },
      ...pageItems.slice(index + 1),
    ];
    pageHistorySet(list);
    setPageItems(list);
  };

  const onMdChange = (id: string, markdown: string) => {
    setPageItems((items) =>
      items.map((item) => {
        if (item.id === id) {
          if (!markdown && markdown !== item.content) {
            message.error("内容不能为空");
          }
          return { ...item, content: markdown };
        }
        return item;
      })
    );
  };

  const onMdBlur = (id: string) => {
    const historyItem = pageHistoryState?.find((item) => item.id === id);
    const currentItem = pageItems.find((item) => item.id === id);
    if (historyItem?.content === currentItem?.content) return;

    const list = pageItems.map((item) => {
      if (item.id === id) {
        return { ...item, id: uuidv4() };
      }
      return item;
    });
    setPageItems(list);
    pageHistorySet(list);
  };

  const onInputChange = (id: string, value: string, type: "title" | "end") => {
    console.log(`输入 ${value} ${type}`);

    if (value.length > 20) {
      message.error("最多支持20个字");
    }
    setPageItems((items) =>
      items.map((item) => {
        if (item.id === id) {
          return type === "title"
            ? { ...item, [type]: value }
            : { ...item, content: value };
        }
        return item;
      })
    );
  };

  return (
    <Layout>
      <Head>
        <title>{TITLE}</title>
        <meta name="description" content={WORKBENCH_DESCRIPTION} />
        <meta name="keywords" content={WORKBENCH_KEYWORDS} />
      </Head>
      <Script
        src="https://public.static.meitudata.com/x-design/domain/mark-domain.js"
        async
      />
      {/* fix wxLogin */}
      <Script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js" />
      <div
        className={cs({
          [styles.webWorkbench]: true,
          [styles.noWriteStep]: !isWriteStep,
        })}
      >
        <Header
          isPersonal={isPersonal}
          onCreate={onCreate}
          isWorkSpace={true}
        />
        {isWriteStep && (
          <div className={styles.content}>
            <div className={styles.title}>
              <span className={styles.tag}>LivePPT</span>
              输入PPT主题
              <br />
              AI生成高质量PPT
              <Image
                className={styles.arrow}
                src={arrow}
                alt="arrow"
                width={63}
              />
            </div>
            <TypeTabs
              tabs={TABS}
              activeTab={activeTab}
              setActiveTab={(v) => {
                chancelUpload.current = true;
                clearTimeout(timer.current);
                setActiveTab(v);
                setTimeout(() => {
                  setLoading(false);
                }, 200);
              }}
            />

            <div
              className={`${styles.inner} ${styles.isInAWordInner}`}
              style={{
                display: isInAWord ? "flex" : "none",
              }}
            >
              <div className={styles.setting}>
                <DeepSeekBtn
                  active={isDeepSeek}
                  onClick={setIsDeepSeek}
                  type="card"
                />
                <PageSelect
                  pageSizeSelect={pageSizeSelect}
                  activePageSize={activePageSize}
                  customLabel={true}
                  onChange={setActivePageSize}
                  className={styles.webPageSelect}
                />
              </div>

              <InAWordContent
                keyword={keyword}
                keywordChangeHandle={keywordChangeHandle}
                placeholder={placeholder}
                enterHandle={enterHandle}
                onCreate={() => {
                  freeCreate({
                    is_recreate: "0",
                  });
                }}
              />
            </div>

            <div
              className={styles.inner}
              style={{
                display: isPasteText ? "flex" : "none",
              }}
            >
              <div className={styles.setting}>
                <PageNumberSelect
                  value={pageNumber.toString()}
                  customLabel={true}
                  onChange={(v) => {
                    setPageNumber(~~v);
                  }}
                />
                <div className={styles.tips}>
                  <IconFont
                    fontSize={12}
                    name="InfoCircle"
                    style={{
                      marginRight: 4,
                    }}
                  />
                  您的内容已加密，仅用于本次AI生成后自动删除
                </div>
              </div>
              <MdEditor
                ref={mdRef}
                onBlur={() => {
                  statTrack("tools_click_ppt_home", {
                    click_type: "paste_text",
                    paste_text_words_number: richTextLen,
                    // 只要markdown出现有序列表，就认为是有序列表
                    paste_text_way: richText.includes("1.")
                      ? "ordered_text"
                      : "disordered_text",
                  });
                }}
                visibleTooltip={visibleTooltip}
                onChange={richTextChange}
                value={mdHtml}
                disabled={isPasteText ? richTextLen === 0 : false}
                onClick={() =>
                  freeCreate({
                    is_recreate: "0",
                  })
                }
              />
            </div>

            <div
              className={styles.inner}
              style={{
                display: isImportFile ? "flex" : "none",
              }}
            >
              <div className={styles.setting}>
                <PageNumberSelect
                  value={pageNumber.toString()}
                  customLabel={true}
                  onChange={(v) => {
                    setPageNumber(~~v);
                  }}
                />
                <div className={styles.tips}>
                  <IconFont
                    fontSize={12}
                    name="InfoCircle"
                    style={{
                      marginRight: 4,
                    }}
                  />
                  您的内容已加密，仅用于本次AI生成后自动删除
                </div>
              </div>
              <ImportFile
                loading={loading}
                chancelUpload={chancelUpload}
                onClose={() => {
                  clearTimeout(timer.current);
                  importFileData.current = "";
                }}
                setLoading={setLoading}
                uploadFile={(file: string, type: string) => {
                  fileUploadCallback(file, type);
                }}
                toPasteText={() => {
                  setActiveTab(TabKey.pasteText);
                }}
              />
            </div>

            {isInAWord && (
              <Try
                keyword={keyword}
                recommendClick={recommendClick}
                activeRecommendIndex={activeRecommendIndex}
                recommendPromptList={recommendPromptList}
              />
            )}
          </div>
        )}

        {/* 大纲输入 */}
        {isWriteStep && (
          <>
            <div
              className={styles.footer}
              style={{
                width: totalWidth,
              }}
            >
              {footerTabs.map((v) => {
                return (
                  <div
                    key={v.key}
                    className={cs({
                      [styles.footerItem]: true,
                      [styles.footerItemActive]: activeFooterTab === v.key,
                    })}
                    onClick={() => {
                      if (v.key === activeFooterTab) return;
                      v.key === FooterTabKey.template &&
                        statTrack("tools_click_ppt_home", {
                          click_type: "ppt_template_tab",
                        });
                      setActiveFooterTab(v.key);
                    }}
                  >
                    <span>{v.title}</span>
                  </div>
                );
              })}
            </div>
            {userInfo?.id && activeFooterTab === FooterTabKey.record ? (
              <Record
                col={col}
                gap={GAP}
                width={WIDHT}
                totalWidth={totalWidth}
                userInfo={userInfo}
                onRecordClick={recordClick}
              />
            ) : null}
            {activeFooterTab === FooterTabKey.template ? (
              <Templates
                col={col}
                gap={GAP}
                width={WIDHT}
                totalWidth={totalWidth}
              />
            ) : null}
          </>
        )}

        {/* 大纲展示 */}
        {(isOutlineStep || isTemplateStep || isPageStep) && (
          <div className={styles.secondContent}>
            <div className={styles.back} onClick={back}>
              <IconFont fontSize={16} name="ChevronLeftBlack" />
            </div>
            <div
              className={cs(styles.treeWrap, {
                [styles.treeWrapPage]: isPageStep,
              })}
            >
              <div className={styles.desc}>
                <div>{TEXT_MAP[step].title}</div>
                <div>
                  {TEXT_MAP[step].desc}

                  {isPageStep && (
                    <Popover
                      placement="rightTop"
                      align={{
                        offset: [0, -18],
                      }}
                      onOpenChange={(v) => {
                        if (!window.localStorage.getItem("pageTips") && !v) {
                          window.localStorage.setItem("pageTips", "true");
                        }
                      }}
                      content={
                        <div className={styles.pageTipsContent}>
                          <IconFont
                            name="CrossBlack"
                            fontSize={12}
                            color="#939599"
                            className={styles.pageTipsContentClose}
                            onClick={() => {
                              // 关闭弹窗
                              pageTipsRef.current?.click();
                            }}
                          />
                          <div className={styles.pageTipsContentTitle}>
                            提示
                          </div>
                          <div className={styles.pageTipsContentList}>
                            <div className={styles.pageTipsContentListItem}>
                              <div
                                className={styles.pageTipsContentListItemTitle}
                              >
                                <Image
                                  src={tipsIcon1}
                                  alt="tipsIcon1"
                                  width={14}
                                  height={14}
                                />
                                逐页生成
                              </div>
                              <div
                                className={styles.pageTipsContentListItemDesc}
                              >
                                按照每张卡片内容逐页生成PPT，您可确认下每张卡片内容
                              </div>
                            </div>
                            <div className={styles.pageTipsContentListItem}>
                              <div
                                className={styles.pageTipsContentListItemTitle}
                              >
                                <Image
                                  src={tipsIcon2}
                                  alt="tipsIcon2"
                                  width={14}
                                  height={14}
                                />
                                编辑卡片
                              </div>
                              <div
                                className={styles.pageTipsContentListItemDesc}
                              >
                                拖拽卡片可移动和合并，可直接增删卡片和修改卡片内容
                              </div>
                            </div>
                            <div className={styles.pageTipsContentListItem}>
                              <div
                                className={styles.pageTipsContentListItemTitle}
                              >
                                <Image
                                  src={tipsIcon3}
                                  alt="tipsIcon3"
                                  width={14}
                                  height={14}
                                />
                                草稿变PPT
                              </div>
                              <div
                                className={styles.pageTipsContentListItemDesc}
                              >
                                从您的笔记或草稿摇身一变高级PPT
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      trigger="click"
                      defaultOpen={
                        window.localStorage.getItem("pageTips") !== "true"
                      }
                      overlayClassName={styles.pageTipsPopover}
                    >
                      <div className={styles.pageTips} ref={pageTipsRef}>
                        <IconFont fontSize={12} name="QuestionMarkCircle" />
                      </div>
                    </Popover>
                  )}
                </div>
              </div>

              {/* 大纲展示 或者 按页生成 */}
              {(isOutlineStep || isPageStep) && (
                <div
                  className={cs({
                    [styles.tree]: true,
                    [styles.pageTree]: isPageStep && !loading,
                    [styles.pageTreeLoading]: isPageStep && loading,
                  })}
                >
                  {loading && (
                    <div className={styles.loading}>
                      <div
                        style={{
                          textAlign: "center",
                          flex: 1,
                        }}
                      >
                        <PPTOutlineLoading
                          width={96}
                          style={{
                            margin: "0 auto",
                          }}
                        />
                        <div className={styles.loadingText}>
                          {isDeepSeek && isOutlineStep
                            ? "DeepSeek R1 正在拼命思考中…"
                            : isPageStep
                            ? "AI自动分页中..."
                            : "小美正在构思中，请稍等..."}
                        </div>
                      </div>
                    </div>
                  )}
                  {!loading && (
                    // @ts-ignore
                    <Scrollbars
                      ref={scrollRef}
                      autoHide={true}
                      className={styles.scroll}
                      style={{
                        borderRadius: isPageStep && !loading ? 0 : 24,
                        // minHeight: 300
                      }}
                    >
                      <div
                        style={{
                          padding:
                            isPageStep && !loading
                              ? "1px 0 25px 0"
                              : "20px 24px 20px 24px",
                        }}
                      >
                        {isPageStep ? (
                          <Pages
                            onReorder={onReorder}
                            onMergeItems={onMerge}
                            onRemoveItem={onRemove}
                            onAddItem={onAdd}
                            onCopyItem={onCopy}
                            onMdChange={onMdChange}
                            onInputChange={onInputChange}
                            onInputBlur={onMdBlur}
                            items={pageItems}
                            onMdBlur={onMdBlur}
                          />
                        ) : (
                          <>
                            {streamEnd && (
                              <OutlineTree
                                treeData={treeData}
                                onChange={treeInputChange}
                                onDeleteTree={onDeleteTree}
                                onAddTree={onAddTree}
                                onBlur={onOutlineBlur}
                              />
                            )}
                            {!streamEnd && !isPreset && (
                              <div
                                className={styles.stream}
                                dangerouslySetInnerHTML={{
                                  __html: streamStr,
                                }}
                              />
                            )}
                            {!streamEnd && isPreset && (
                              <CustomTyped
                                domStr={streamStr}
                                className="stream"
                                onComplete={onPresetStreamTypedComplete}
                              />
                            )}
                            {!outlineEnd && (
                              <PPTOutlineLoading
                                width={48}
                                style={{
                                  margin: "0 auto",
                                }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </Scrollbars>
                  )}
                </div>
              )}

              {/* 模板选择 */}
              {isTemplateStep && (
                <TemplateSelect
                  tagSelect={tagSelect}
                  activeTag={activeTag}
                  setActiveTag={setActiveTag}
                  activeTemplate={activeTemplate}
                  templateList={templateList}
                  setActiveTemplate={setActiveTemplate}
                  handleErrorMessage={handleErrorMessage}
                  onGen={() => createAiPPT()}
                />
              )}
              {(isOutlineStep || isWriteStep || isPageStep) && (
                <div className={styles.outlineTag}>
                  {activeTab === TabKey.inAWord && (
                    <TagSelect
                      list={lenSelect}
                      active={activeLen}
                      config={{
                        label: "name",
                        value: "value",
                      }}
                      title="PPT文字内容"
                      onTagSelect={(v) => {
                        statTrack("tools_click_ppt_home", {
                          click_type: "words_number",
                        });
                        setActiveLen(v);
                      }}
                    />
                  )}
                  {(activeTab === TabKey.pasteText ||
                    activeTab === TabKey.importFile) && (
                    <TagSelect
                      list={generateTypeSelect}
                      active={activeGenerateType}
                      config={{
                        label: "name",
                        value: "value",
                        desc: "desc",
                        icon: "icon",
                      }}
                      title="PPT文本内容"
                      onTagSelect={(v) => {
                        statTrack("tools_click_ppt_home", {
                          click_type: "words_number",
                        });
                        setActiveGenerateType(v);
                      }}
                    />
                  )}
                </div>
              )}
            </div>

            {(isOutlineStep || isPageStep) && (
              <div className={styles.buttons}>
                <Button className={styles.refresh} onClick={refresh}>
                  重新生成
                </Button>
                <Button
                  disabled={
                    isPageStep
                      ? loading || !pageItems.length
                      : pptLoading || loading || !outlineEnd || !treeData.length
                  }
                  className={styles.next}
                  type="primary"
                  onClick={() => {
                    if (!clickAble.current) return;
                    clickAble.current = false;
                    setTimeout(() => {
                      clickAble.current = true;
                    }, 2000);
                    handleNext();
                  }}
                >
                  选择模板
                  <Image
                    src={nextArrow}
                    alt=""
                    style={{
                      marginLeft: 8,
                      width: 16,
                      height: 13,
                    }}
                  />
                </Button>
              </div>
            )}
          </div>
        )}

        <PromotionComponent triggerPage={8192} />

        <OverseasAccessModal track={statTrack} />

        {/* 在线咨询 */}
        <FloatHelp
          userInfo={userInfo}
          projectName="海报编辑"
          isShowCommunity={false}
          hideBusiness={false}
          size="small"
        />

        <div className={styles.disclaimer}>
          <Disclaimer placement="top" direction="row" />
        </div>

        {createPPTLoading && (
          <CreatePPTProgress
            percent={createPPTPercent}
            onClose={cancelCreatePPT}
          />
        )}
      </div>
    </Layout>
  );
};

export default React.memo(WebWorkbench);
